import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject} from 'rxjs';

@Component({
  templateUrl: './pdf.component.html'

})export class PdfShowComponent implements OnInit {
  public language = language;
  public frmGroup: FormGroup;
  public id: number = 0;
  public isEdit: boolean = false;
  public isSuDung: boolean = true;
  public submitValidate = false;
  public onClose: Subject<boolean>;
  public pdfSrc: string;
  private rotation: number = 0;
  private zoom: number = 0;




  constructor(public bsModalService: BsModalService,
              public _bsModalRef: BsModalRef,
  ) {

  }
  ngOnInit(): void {
    this.onClose = new Subject();


  }
  private rotationPdf()
  {
      if(this.rotation === 360)
        this.rotation = 0;
      this.rotation += 90;
  }
  public show(url: string)
  {
    this.pdfSrc= url;
  }

  public onConfirm(): void {

   this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  getLocalPdfUrl = async () => {

    const response = await fetch(this.pdfSrc);
    const blob = await response.blob();
    return URL.createObjectURL(blob);


  };
  private print(): void {
   this.getLocalPdfUrl().then(function(data) {
     const iframe = document.createElement('iframe');
     iframe.id = 'ifr-pdf';
     iframe.style.visibility = 'hidden';
     iframe.src = data;
     document.body.appendChild(iframe);
     window.setTimeout(function() {
       iframe.contentWindow.print();
     }, 1000);
   });
  }
}
